<template lang="pug">
  .banner-vm
    div.banner-vm__box__content.d-none.d-lg-block
      img(src="https://storage.googleapis.com/vivemas/home/banner_vivemas.png" alt="Banner Vivemas")
  </template>
  
  <script>
  
  export default {
    props: ['callback', 'isOnlySoat'],
    data: () => ({
      logo: ('https://storage.googleapis.com/vivemas/home/img-vive-logo.png'),
    }),
    methods: {
    }
  }
  </script>
  
  <style >
  .landing-vivemas .banner-vm {
    padding-top: 2rem;
  }
  
  .landing-vivemas .banner-vm img {
    width: 100%;
  }
  
  
  .landing-vivemas .banner-vm__box__content img {
    width: 100%;
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/vivemas/Banner.vue